// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6d79647","952":"b3f96533"}[chunkId] + ".chunk.js";
};